import {Mortalities, MortalityImplants, Proximities, Separations, TrapEvents, VaginalImplants, VirtualFenceEvents, Activities, CollarLogs, GPSPositions} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class EventsServices {
  constructor(
    public Mortality: Mortalities,
    public MortalityImplant: MortalityImplants,
    public Proximity: Proximities,
    public Separation: Separations,
    public Trap: TrapEvents,
    public VaginalImplant: VaginalImplants,
    public VirtualFence: VirtualFenceEvents,
    public Activity: Activities,
    public CollarLog: CollarLogs,
    public Position: GPSPositions,
  ) {}
}